import _classCallCheck from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * @class
 * @implements MiddlewareOptions
 * Class for RetryHandlerOptions
 */
export var RetryHandlerOptions =
/*#__PURE__*/
function () {
  /**
   * @public
   * @constructor
   * To create an instance of RetryHandlerOptions
   * @param {number} [delay = RetryHandlerOptions.DEFAULT_DELAY] - The delay value in seconds
   * @param {number} [maxRetries = RetryHandlerOptions.DEFAULT_MAX_RETRIES] - The maxRetries value
   * @param {ShouldRetry} [shouldRetry = RetryHandlerOptions.DEFAULT_SHOULD_RETRY] - The shouldRetry callback function
   * @returns An instance of RetryHandlerOptions
   */
  function RetryHandlerOptions() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RetryHandlerOptions.DEFAULT_DELAY;
    var maxRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RetryHandlerOptions.DEFAULT_MAX_RETRIES;
    var shouldRetry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RetryHandlerOptions.DEFAULT_SHOULD_RETRY;

    _classCallCheck(this, RetryHandlerOptions);

    if (delay > RetryHandlerOptions.MAX_DELAY && maxRetries > RetryHandlerOptions.MAX_MAX_RETRIES) {
      var error = new Error("Delay and MaxRetries should not be more than ".concat(RetryHandlerOptions.MAX_DELAY, " and ").concat(RetryHandlerOptions.MAX_MAX_RETRIES));
      error.name = "MaxLimitExceeded";
      throw error;
    } else if (delay > RetryHandlerOptions.MAX_DELAY) {
      var _error = new Error("Delay should not be more than ".concat(RetryHandlerOptions.MAX_DELAY));

      _error.name = "MaxLimitExceeded";
      throw _error;
    } else if (maxRetries > RetryHandlerOptions.MAX_MAX_RETRIES) {
      var _error2 = new Error("MaxRetries should not be more than ".concat(RetryHandlerOptions.MAX_MAX_RETRIES));

      _error2.name = "MaxLimitExceeded";
      throw _error2;
    }

    this.delay = Math.min(delay, RetryHandlerOptions.MAX_DELAY);
    this.maxRetries = Math.min(maxRetries, RetryHandlerOptions.MAX_MAX_RETRIES);
    this.shouldRetry = shouldRetry;
  }
  /**
   * @public
   * To get the maximum delay
   * @returns A maximum delay
   */


  _createClass(RetryHandlerOptions, [{
    key: "getMaxDelay",
    value: function getMaxDelay() {
      return RetryHandlerOptions.MAX_DELAY;
    }
  }]);

  return RetryHandlerOptions;
}();
/**
 * @private
 * @static
 * A member holding default delay value in seconds
 */

RetryHandlerOptions.DEFAULT_DELAY = 3;
/**
 * @private
 * @static
 * A member holding default maxRetries value
 */

RetryHandlerOptions.DEFAULT_MAX_RETRIES = 3;
/**
 * @private
 * @static
 * A member holding maximum delay value in seconds
 */

RetryHandlerOptions.MAX_DELAY = 180;
/**
 * @private
 * @static
 * A member holding maximum maxRetries value
 */

RetryHandlerOptions.MAX_MAX_RETRIES = 10;
/**
 * @private
 * A member holding default shouldRetry callback
 */

RetryHandlerOptions.DEFAULT_SHOULD_RETRY = function () {
  return true;
};